import React from 'react';
export function Footer() {
  return <footer className="bg-[#1A2E1E] pt-20 pb-10 border-t border-white/10" data-id="element-145">
      <div className="container mx-auto px-4" data-id="element-146">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16 max-w-6xl mx-auto" data-id="element-147">
          <div className="md:col-span-1" data-id="element-148">
            <h3 className="text-2xl font-playfair font-bold text-white mb-6 flex items-center gap-2" data-id="element-149">
              🧠 Bóveda Digital™
            </h3>
            <p className="text-white/70 font-poppins text-sm leading-relaxed" data-id="element-150">
              Creamos recursos digitales prácticos y basados en evidencia para
              acompañar a las familias en la crianza respetuosa, sin perder la
              cordura en el intento.
            </p>
          </div>

          <div className="md:col-span-1" data-id="element-151">
            <h3 className="text-lg font-poppins font-bold text-white mb-6 uppercase tracking-wider" data-id="element-152">
              Navegación
            </h3>
            <ul className="space-y-3 text-white/70 font-poppins text-sm" data-id="element-153">
              <li data-id="element-154">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-155">
                  ¿Qué es Bóveda Digital?
                </a>
              </li>
              <li data-id="element-156">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-157">
                  ¿Por qué elegirnos?
                </a>
              </li>
              <li data-id="element-158">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-159">
                  ¿Cómo funciona?
                </a>
              </li>
              <li data-id="element-160">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-161">
                  ¿Qué ofrecemos?
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-1" data-id="element-162">
            <h3 className="text-lg font-poppins font-bold text-white mb-6 uppercase tracking-wider" data-id="element-163">
              Contacto
            </h3>
            <ul className="space-y-4 text-white/70 font-poppins text-sm" data-id="element-164">
              <li data-id="element-165">
                <a href="mailto:soportebovedadigital@gmail.com" className="flex items-center gap-3 hover:text-gold transition-colors" data-id="element-166">
                  <span className="text-xl" data-id="element-167">📧</span>{' '}
                  soportebovedadigital@gmail.com
                </a>
              </li>
              <li data-id="element-168">
                <a href="#" className="flex items-center gap-3 hover:text-gold transition-colors" data-id="element-169">
                  <span className="text-xl" data-id="element-170">📲</span> @boveda.digital.ok
                </a>
              </li>
              <li data-id="element-171">
                <a href="#" className="flex items-center gap-3 hover:text-gold transition-colors" data-id="element-172">
                  <span className="text-xl" data-id="element-173">🌐</span> www.bovedadigital.online
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 text-center" data-id="element-174">
          <p className="text-white/40 font-poppins text-xs leading-relaxed max-w-4xl mx-auto" data-id="element-175">
            Aviso legal: Este sitio es independiente y no está afiliado a Meta
            Platforms Inc. Los resultados pueden variar. ©{' '}
            {new Date().getFullYear()} Bóveda Digital™
          </p>
        </div>
      </div>
    </footer>;
}